import { Affix, Button, Card } from "antd";
import { Fragment, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CARTON_INVENTORY_LIST } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import ListTable from "common/ListTable";
import {
  CARTON_INVENTORY_CREATE_PERMISSION,
  CARTON_INVENTORY_VIEW_PERMISSION,
} from "../../../routes/permissions";
import { hasPermission } from "../../../utils/functions";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import InventoryLayOutCommon from "../../InventoryTrims/LayOut/InventoryLayOutCommon";

const CartonInventoryList = (props) => {
  const { width } = props;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchList = useCallback(async (page) => {
    if (!hasPermission([CARTON_INVENTORY_VIEW_PERMISSION])) return;
    setLoading(true);
    setError(null);
    const response = await getData(`${CARTON_INVENTORY_LIST}?page=${page}`);
    if (response?.data?.code === 200) {
      const payload = response?.data?.data;
      if (Array.isArray(payload)) {
        setRows(payload);
        setTotalData(payload.length);
      } else {
        setRows(payload?.data ?? []);
        setTotalData(payload?.total ?? 0);
        setPageSize(payload?.per_page ?? 10);
      }
    } else {
      setRows([]);
      setTotalData(0);
      setError("Could not load this list.");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchList(currentPage);
  }, [currentPage, fetchList]);

  const columns = [
    { title: "Supplier PO", key: "supplier_po", ellipsis: true, render: (_, r) => r?.supplier_po_number || "—" },
    { title: "Buyer", key: "buyer", ellipsis: true, render: (_, r) => r?.buyer?.name || r?.buyer_info?.name || "—" },
    { title: "Supplier", key: "supplier", ellipsis: true, render: (_, r) => r?.supplier?.name || r?.supplier_info?.name || "—" },
    { title: "Movement Type", key: "movement_type", width: 160, ellipsis: true, render: (_, r) => r?.movement_type || "—" },
    { title: "Challan No", key: "challan", width: 120, ellipsis: true, render: (_, r) => r?.challan_no || r?.challan_info?.challan_no || "—" },
  ];

  const cardWidth = isMobileView() ? "100%" : width ? `${width}px` : "100%";

  return (
    <Fragment>
      <InventoryLayOutCommon>
        <Affix offsetTop={0}>
          <Card className="p-fixed" style={{ width: cardWidth }}>
            <Header
              title="Carton Inventory"
              subTitle=""
              actions={[
                <Button
                  key="add"
                  size="small"
                  type="primary"
                  disabled={!hasPermission([CARTON_INVENTORY_CREATE_PERMISSION])}
                >
                  <Link to="/inventory/carton-inventory/add">
                    {hasPermission([CARTON_INVENTORY_CREATE_PERMISSION]) ? "Add new" : "No permission"}
                  </Link>
                </Button>,
              ]}
            />
          </Card>
        </Affix>

        <div className="containt-body">
          <Card>
            <ListTable
              bordered
              size="small"
              loading={loading}
              error={error}
              onRetry={() => fetchList(currentPage)}
              emptyText="No records to show yet."
              dataSource={rows}
              rowKey={(r, i) => r?.id ?? i}
              columns={columns}
              pagination={{
                showSizeChanger: false,
                current: currentPage,
                total: totalData,
                pageSize,
                onChange: (page) => setCurrentPage(page),
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </Card>
        </div>
      </InventoryLayOutCommon>
    </Fragment>
  );
};

export default CartonInventoryList;
